/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ErrorResponse,
  PaginatedGenerationLogList,
  PaginatedTrackListList,
  PaginatedTrackVersionList,
  PatchedTrackUpdateRequest,
  TrackCopyMoveRequest,
  TrackCreateRequest,
  TrackDetail,
  TrackGetLogsParams,
  TrackGetVersionsParams,
  TrackListParams,
  TrackUpdateRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자 플레이리스트의 모든 트랙을 조회합니다. 플레이리스트 ID 또는 채널 ID로 필터링 가능합니다.
 * @summary 트랙 목록 조회
 */
export const trackList = (
  params?: TrackListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedTrackListList>(
    { url: `/api/tracks/`, method: "GET", params, signal },
    options,
  );
};

export const getTrackListQueryKey = (params?: TrackListParams) => {
  return [`/api/tracks/`, ...(params ? [params] : [])] as const;
};

export const getTrackListQueryOptions = <
  TData = Awaited<ReturnType<typeof trackList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrackListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trackList>>> = ({
    signal,
  }) => trackList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof trackList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrackListQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackList>>
>;
export type TrackListQueryError = ErrorType<ErrorResponse>;

export function useTrackList<
  TData = Awaited<ReturnType<typeof trackList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | TrackListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackList>>,
          TError,
          Awaited<ReturnType<typeof trackList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackList<
  TData = Awaited<ReturnType<typeof trackList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackList>>,
          TError,
          Awaited<ReturnType<typeof trackList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackList<
  TData = Awaited<ReturnType<typeof trackList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트랙 목록 조회
 */

export function useTrackList<
  TData = Awaited<ReturnType<typeof trackList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrackListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트에 새 트랙을 추가합니다.
 * @summary 트랙 생성
 */
export const trackCreate = (
  trackCreateRequest: BodyType<TrackCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/tracks/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackCreateRequest,
      signal,
    },
    options,
  );
};

export const getTrackCreateMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackCreate>>,
    TError,
    { data: BodyType<TrackCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackCreate>>,
  TError,
  { data: BodyType<TrackCreateRequest> },
  TContext
> => {
  const mutationKey = ["trackCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackCreate>>,
    { data: BodyType<TrackCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return trackCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackCreate>>
>;
export type TrackCreateMutationBody = BodyType<TrackCreateRequest>;
export type TrackCreateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 생성
 */
export const useTrackCreate = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackCreate>>,
      TError,
      { data: BodyType<TrackCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackCreate>>,
  TError,
  { data: BodyType<TrackCreateRequest> },
  TContext
> => {
  const mutationOptions = getTrackCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트랙의 상세 정보와 모든 버전을 조회합니다.
 * @summary 트랙 상세 조회
 */
export const trackRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    { url: `/api/tracks/${id}/`, method: "GET", signal },
    options,
  );
};

export const getTrackRetrieveQueryKey = (id?: string) => {
  return [`/api/tracks/${id}/`] as const;
};

export const getTrackRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof trackRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrackRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trackRetrieve>>> = ({
    signal,
  }) => trackRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrackRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackRetrieve>>
>;
export type TrackRetrieveQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useTrackRetrieve<
  TData = Awaited<ReturnType<typeof trackRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackRetrieve>>,
          TError,
          Awaited<ReturnType<typeof trackRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackRetrieve<
  TData = Awaited<ReturnType<typeof trackRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackRetrieve>>,
          TError,
          Awaited<ReturnType<typeof trackRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackRetrieve<
  TData = Awaited<ReturnType<typeof trackRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트랙 상세 조회
 */

export function useTrackRetrieve<
  TData = Awaited<ReturnType<typeof trackRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrackRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 트랙의 모든 필드를 수정합니다.
 * @summary 트랙 전체 수정
 */
export const trackUpdate = (
  id: string,
  trackUpdateRequest: BodyType<TrackUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/tracks/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackUpdateRequest,
    },
    options,
  );
};

export const getTrackUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackUpdate>>,
    TError,
    { id: string; data: BodyType<TrackUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackUpdate>>,
  TError,
  { id: string; data: BodyType<TrackUpdateRequest> },
  TContext
> => {
  const mutationKey = ["trackUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackUpdate>>,
    { id: string; data: BodyType<TrackUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackUpdate>>
>;
export type TrackUpdateMutationBody = BodyType<TrackUpdateRequest>;
export type TrackUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 전체 수정
 */
export const useTrackUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackUpdate>>,
      TError,
      { id: string; data: BodyType<TrackUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackUpdate>>,
  TError,
  { id: string; data: BodyType<TrackUpdateRequest> },
  TContext
> => {
  const mutationOptions = getTrackUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트랙의 일부 필드만 수정합니다.
 * @summary 트랙 부분 수정
 */
export const trackPartialUpdate = (
  id: string,
  patchedTrackUpdateRequest: BodyType<PatchedTrackUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/tracks/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedTrackUpdateRequest,
    },
    options,
  );
};

export const getTrackPartialUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedTrackUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedTrackUpdateRequest> },
  TContext
> => {
  const mutationKey = ["trackPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackPartialUpdate>>,
    { id: string; data: BodyType<PatchedTrackUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackPartialUpdate>>
>;
export type TrackPartialUpdateMutationBody =
  BodyType<PatchedTrackUpdateRequest>;
export type TrackPartialUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 부분 수정
 */
export const useTrackPartialUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedTrackUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedTrackUpdateRequest> },
  TContext
> => {
  const mutationOptions = getTrackPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트랙을 삭제합니다.
 * @summary 트랙 삭제
 */
export const trackDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/tracks/${id}/`, method: "DELETE" },
    options,
  );
};

export const getTrackDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["trackDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return trackDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackDestroy>>
>;

export type TrackDestroyMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 삭제
 */
export const useTrackDestroy = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getTrackDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트랙을 다른 플레이리스트로 복제합니다. 모든 버전도 함께 복제됩니다.
 * @summary 트랙 복제
 */
export const trackCopy = (
  id: string,
  trackCopyMoveRequest: BodyType<TrackCopyMoveRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/tracks/${id}/copy/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackCopyMoveRequest,
      signal,
    },
    options,
  );
};

export const getTrackCopyMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackCopy>>,
    TError,
    { id: string; data: BodyType<TrackCopyMoveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackCopy>>,
  TError,
  { id: string; data: BodyType<TrackCopyMoveRequest> },
  TContext
> => {
  const mutationKey = ["trackCopy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackCopy>>,
    { id: string; data: BodyType<TrackCopyMoveRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackCopy(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackCopyMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackCopy>>
>;
export type TrackCopyMutationBody = BodyType<TrackCopyMoveRequest>;
export type TrackCopyMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 복제
 */
export const useTrackCopy = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackCopy>>,
      TError,
      { id: string; data: BodyType<TrackCopyMoveRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackCopy>>,
  TError,
  { id: string; data: BodyType<TrackCopyMoveRequest> },
  TContext
> => {
  const mutationOptions = getTrackCopyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 같은 플레이리스트 내에서 트랙의 프롬프트(제목, 가사, 스타일 등)만 복사하여 새 트랙을 생성합니다. 버전, 오디오, 비디오, 썸네일은 복사하지 않습니다.
 * @summary 트랙 프롬프트 복제
 */
export const trackDuplicate = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    { url: `/api/tracks/${id}/duplicate/`, method: "POST", signal },
    options,
  );
};

export const getTrackDuplicateMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackDuplicate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["trackDuplicate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackDuplicate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return trackDuplicate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackDuplicateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackDuplicate>>
>;

export type TrackDuplicateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 프롬프트 복제
 */
export const useTrackDuplicate = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackDuplicate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getTrackDuplicateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * metadata_ready 상태인 트랙에 대해 음악 생성을 시작합니다. 메타데이터를 재생성하지 않고 기존 메타데이터(suno_style, lyrics, image_prompt 등)를 사용하여 Suno API로 음악을 생성합니다. 이미 audio_url이 채워진 TrackVersion이 2개 이상 있으면 자동 skip합니다(누적 방지). 강제 재생성하려면 ?force=true 쿼리 파라미터를 전달하세요.
 * @summary 트랙 음악 생성
 */
export const trackGenerateMusic = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void | void>(
    { url: `/api/tracks/${id}/generate-music/`, method: "POST", signal },
    options,
  );
};

export const getTrackGenerateMusicMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackGenerateMusic>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackGenerateMusic>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["trackGenerateMusic"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackGenerateMusic>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return trackGenerateMusic(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackGenerateMusicMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackGenerateMusic>>
>;

export type TrackGenerateMusicMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 음악 생성
 */
export const useTrackGenerateMusic = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackGenerateMusic>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackGenerateMusic>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getTrackGenerateMusicMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 해당 트랙의 모든 생성 로그를 조회합니다. 각 생성 단계(메타데이터, 음악, 썸네일 등)의 상태와 소요 시간을 확인할 수 있습니다.
 * @summary 트랙 생성 로그 조회
 */
export const trackGetLogs = (
  id: string,
  params?: TrackGetLogsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedGenerationLogList>(
    { url: `/api/tracks/${id}/logs/`, method: "GET", params, signal },
    options,
  );
};

export const getTrackGetLogsQueryKey = (
  id?: string,
  params?: TrackGetLogsParams,
) => {
  return [`/api/tracks/${id}/logs/`, ...(params ? [params] : [])] as const;
};

export const getTrackGetLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof trackGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackGetLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTrackGetLogsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trackGetLogs>>> = ({
    signal,
  }) => trackGetLogs(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackGetLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrackGetLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackGetLogs>>
>;
export type TrackGetLogsQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useTrackGetLogs<
  TData = Awaited<ReturnType<typeof trackGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params: undefined | TrackGetLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackGetLogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackGetLogs>>,
          TError,
          Awaited<ReturnType<typeof trackGetLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackGetLogs<
  TData = Awaited<ReturnType<typeof trackGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackGetLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackGetLogs>>,
          TError,
          Awaited<ReturnType<typeof trackGetLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackGetLogs<
  TData = Awaited<ReturnType<typeof trackGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackGetLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트랙 생성 로그 조회
 */

export function useTrackGetLogs<
  TData = Awaited<ReturnType<typeof trackGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trackGetLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrackGetLogsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 트랙을 다른 플레이리스트로 이동합니다. 원본 플레이리스트에서 트랙이 제거됩니다.
 * @summary 트랙 이동
 */
export const trackMove = (
  id: string,
  trackCopyMoveRequest: BodyType<TrackCopyMoveRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/tracks/${id}/move/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackCopyMoveRequest,
      signal,
    },
    options,
  );
};

export const getTrackMoveMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackMove>>,
    TError,
    { id: string; data: BodyType<TrackCopyMoveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackMove>>,
  TError,
  { id: string; data: BodyType<TrackCopyMoveRequest> },
  TContext
> => {
  const mutationKey = ["trackMove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackMove>>,
    { id: string; data: BodyType<TrackCopyMoveRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackMove(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackMove>>
>;
export type TrackMoveMutationBody = BodyType<TrackCopyMoveRequest>;
export type TrackMoveMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 이동
 */
export const useTrackMove = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackMove>>,
      TError,
      { id: string; data: BodyType<TrackCopyMoveRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackMove>>,
  TError,
  { id: string; data: BodyType<TrackCopyMoveRequest> },
  TContext
> => {
  const mutationOptions = getTrackMoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 트랙을 재생성합니다. 메타데이터, 음악, 썸네일, 비디오를 다시 생성합니다. 플레이리스트의 다른 트랙에는 영향을 주지 않습니다.
 * @summary 트랙 재생성
 */
export const trackRegenerate = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/tracks/${id}/regenerate/`, method: "POST", signal },
    options,
  );
};

export const getTrackRegenerateMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackRegenerate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackRegenerate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["trackRegenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackRegenerate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return trackRegenerate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackRegenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackRegenerate>>
>;

export type TrackRegenerateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 재생성
 */
export const useTrackRegenerate = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackRegenerate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackRegenerate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getTrackRegenerateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * music_generating 상태에서 5분 이상 멈춘 트랙을 failed 상태로 리셋합니다. 리셋 후 사용자가 재시도할 수 있습니다.
 * @summary 스턱 트랙 리셋
 */
export const trackResetStuck = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/tracks/${id}/reset-stuck/`, method: "POST", signal },
    options,
  );
};

export const getTrackResetStuckMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackResetStuck>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackResetStuck>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["trackResetStuck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackResetStuck>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return trackResetStuck(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackResetStuckMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackResetStuck>>
>;

export type TrackResetStuckMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 스턱 트랙 리셋
 */
export const useTrackResetStuck = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackResetStuck>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackResetStuck>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getTrackResetStuckMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트랙에서 특정 버전을 선택합니다. 선택된 버전의 오디오가 트랙의 기본 오디오가 됩니다.
 * @summary 버전 선택
 */
export const trackSelectVersion = (
  id: string,
  trackCreateRequest: BodyType<TrackCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/tracks/${id}/select_version/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackCreateRequest,
      signal,
    },
    options,
  );
};

export const getTrackSelectVersionMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackSelectVersion>>,
    TError,
    { id: string; data: BodyType<TrackCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackSelectVersion>>,
  TError,
  { id: string; data: BodyType<TrackCreateRequest> },
  TContext
> => {
  const mutationKey = ["trackSelectVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackSelectVersion>>,
    { id: string; data: BodyType<TrackCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackSelectVersion(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackSelectVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackSelectVersion>>
>;
export type TrackSelectVersionMutationBody = BodyType<TrackCreateRequest>;
export type TrackSelectVersionMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전 선택
 */
export const useTrackSelectVersion = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackSelectVersion>>,
      TError,
      { id: string; data: BodyType<TrackCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackSelectVersion>>,
  TError,
  { id: string; data: BodyType<TrackCreateRequest> },
  TContext
> => {
  const mutationOptions = getTrackSelectVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트랙에 커스텀 썸네일 이미지를 업로드합니다. 지원 형식: JPG, PNG, WebP. 최대 크기: 5MB.
 * @summary 썸네일 업로드
 */
export const trackUploadThumbnail = (
  id: string,
  trackCreateRequest: BodyType<TrackCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/tracks/${id}/upload_thumbnail/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackCreateRequest,
      signal,
    },
    options,
  );
};

export const getTrackUploadThumbnailMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackUploadThumbnail>>,
    TError,
    { id: string; data: BodyType<TrackCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackUploadThumbnail>>,
  TError,
  { id: string; data: BodyType<TrackCreateRequest> },
  TContext
> => {
  const mutationKey = ["trackUploadThumbnail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackUploadThumbnail>>,
    { id: string; data: BodyType<TrackCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackUploadThumbnail(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackUploadThumbnailMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackUploadThumbnail>>
>;
export type TrackUploadThumbnailMutationBody = BodyType<TrackCreateRequest>;
export type TrackUploadThumbnailMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 썸네일 업로드
 */
export const useTrackUploadThumbnail = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackUploadThumbnail>>,
      TError,
      { id: string; data: BodyType<TrackCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackUploadThumbnail>>,
  TError,
  { id: string; data: BodyType<TrackCreateRequest> },
  TContext
> => {
  const mutationOptions = getTrackUploadThumbnailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 해당 트랙의 모든 버전을 조회합니다. 버전은 생성 중에 자주 변경되므로 60초 TTL로 캐싱됩니다.
 * @summary 트랙 버전 목록 조회
 */
export const trackGetVersions = (
  id: string,
  params?: TrackGetVersionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedTrackVersionList>(
    { url: `/api/tracks/${id}/versions/`, method: "GET", params, signal },
    options,
  );
};

export const getTrackGetVersionsQueryKey = (
  id?: string,
  params?: TrackGetVersionsParams,
) => {
  return [`/api/tracks/${id}/versions/`, ...(params ? [params] : [])] as const;
};

export const getTrackGetVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof trackGetVersions>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackGetVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTrackGetVersionsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackGetVersions>>
  > = ({ signal }) => trackGetVersions(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackGetVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrackGetVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackGetVersions>>
>;
export type TrackGetVersionsQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useTrackGetVersions<
  TData = Awaited<ReturnType<typeof trackGetVersions>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params: undefined | TrackGetVersionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackGetVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackGetVersions>>,
          TError,
          Awaited<ReturnType<typeof trackGetVersions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackGetVersions<
  TData = Awaited<ReturnType<typeof trackGetVersions>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackGetVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackGetVersions>>,
          TError,
          Awaited<ReturnType<typeof trackGetVersions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackGetVersions<
  TData = Awaited<ReturnType<typeof trackGetVersions>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackGetVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트랙 버전 목록 조회
 */

export function useTrackGetVersions<
  TData = Awaited<ReturnType<typeof trackGetVersions>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: TrackGetVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackGetVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrackGetVersionsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
